<script>
import moment from 'moment'
import DragModal from '@/components/DragModal/DragModal.vue'
export default {
  components: { DragModal },
  data() {
    return {
      formValue: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 14 }
      }
    }
  },
  methods: {
    moment,
    onClose() {
      this.$emit('close')
    },
    onSubmit() {
      this.formValue.validateFields((err, values) => {
        if (!err) {
          this.$emit('search', values)
        }
      })
    },
    onReset(){
      this.formValue.resetFields();
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    subTitle:{
      type:String,
      default:''
    },
    form: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    value: {
      handler() {
        if (this.visible) {
          Object.keys(this.value).forEach((key) => {
            this.formValue.setFieldsValue(key, this.value[key])
          })
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<template>
  <drag-modal
    :title="$t('advanced_search')"
    :subTitle="subTitle"
    placement="right"
    :closable="false"
    :visible="visible"
    :get-container="false"
    :wrap-style="{ position: 'absolute' }"
    width="600px"
    top="124px"
    @close="onClose"
  >
    <a-form :form="formValue" ref="form">
      <template v-for="(item, index) in form">
        <a-form-item
          :key="index"
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="item.name"
        >
          <a-date-picker
            v-if="item.slot === 'time'"
            format="YYYY-MM-DD HH:mm:ss"
            style="width: 100%"
            v-decorator="[item.key]"
            :placeholder="$t('please_select') + item.name"
            allClear
            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
          />
          <a-range-picker
            v-else-if="item.slot === 'date'"
            format="YYYY-MM-DD HH:mm:ss"
            style="width: 100%"
            v-decorator="[item.key]"
            allClear
            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
          />
          <a-input
            v-else-if="item.slot === 'input'"
            style="width: 100%"
            v-decorator="[item.key]"
            :placeholder="$t('common_please_input') + item.name"
            allClear
          />
        </a-form-item>
      </template>
    </a-form>
    <div
      slot="footer"
      :style="{
        textAlign: 'center'
      }"
    >
      <a-button type="primary" @click="onSubmit">
        {{$t('common_search')}}
      </a-button>
      <a-button :style="{ marginLeft: '10px' }" @click="onReset">
         {{$t('common_reset')}}
      </a-button>

    </div>
  </drag-modal>
</template>

<style scoped></style>
